var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_vm._t("subnav"),_vm._v(" "),_c('div',{staticClass:"main--content container"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }